import { useState } from 'react';
import { observable, when } from 'mobx';

import { fetchFeaturedRatesSortedByLowest } from '@ratehub/mtg-common';


function useMortgageRecommendedRate() {
    const [ state ] = useState(() => observable({
        recommendedRate: null,
        isFetching: false,
        hasError: false,

        async fetchRecommendedRate({ scenario, ...params }) {
            // Make sure to wait until an existing fetch is completed
            if (state.isFetching) {
                await when(() => !state.isFetching);
            }

            state.isFetching = true;

            try {
                const [ lowestRate ] = await fetchFeaturedRatesSortedByLowest({
                    scenario,
                    ...params,
                });

                state.recommendedRate = lowestRate;

                state.isFetching = false;
            } catch {
                // Note: Error is noticed within fetchFeaturedRatesSortedByLowest
                state.isFetching = false;
            }
        },
    }));

    return state;
}


export default useMortgageRecommendedRate;